import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "14", height: "6", x: "5", y: "14", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "10", height: "6", x: "7", y: "4", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 7h-5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 7H1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 17h-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 17H2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "AlignVerticalDistributeCenter";
const AlignVerticalDistributeCenter = memo(themed(Icon));
export {
  AlignVerticalDistributeCenter
};
//# sourceMappingURL=align-vertical-distribute-center.js.map
